import axios from "axios";

class CaseDetailsApi {

  // Generic API call method
  genericDatamartAPI = async (apiConfig: any) => {
    try {
      const response = await axios(apiConfig);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message || 'API call failed');
    }
  }

  getCaseDetails = async () => {
    try {
      const apiConfig = {
        method: 'get',
        url: `${process.env.REACT_APP_DATAMART}/offer/getOfferCaseTypes`
      };
      const response = await this.genericDatamartAPI(apiConfig);
      return response;
    } catch (error: any) {
      return { status: false, message: error.message || 'Unknown error' };
    }
  }

}

const CASE_DETAILS_API = new CaseDetailsApi();
export default CASE_DETAILS_API;